import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';

const PAYMENT_STATUS_BUTTON_CONFIG = {
  pending: { text: 'Pending', className: 'btn PendingBtn' },
  pastdue: { text: 'Past Due', className: 'btn PastDueBtn' },
  paid: { text: 'Paid', className: 'btn paidBtn' },
  submitted: { text: 'Submitted', className: 'btn SubmittedBtn' },
  declined: { text: 'Declined', className: 'btn DeclinedBtn' },
  rejected: { text: 'Rejected', className: 'btn DeclinedBtn' },
  failed: { text: 'Failed', className: 'btn DeclinedBtn' },
  refunded: { text: 'Refunded', className: 'btn RefundedBtn' },
  voided: { text: 'Voided', className: 'btn PendingBtn' },
  deleted: { text: 'Deleted', className: 'btn DeclinedBtn' },
  archived: { text: 'Archived', className: 'btn ArchivedBtn' },
  unpaid: { text: 'Unpaid', className: 'btn PendingBtn' },
  inqueue: { text: 'In Queue', className: 'btn PendingBtn' },
  yet_to_pay: { text: 'Yet to Pay', className: 'btn PendingBtn' },
  visited: { text: 'Visited', className: 'btn PendingBtn' },
  success: { text: 'Success', className: 'btn paidBtn' }, // Recurring status
  updated: { text: 'Updated', className: 'btn RefundedBtn' }, // Recurring status
};

const PaymentStatus = (props) => {
  const statusConfig = PAYMENT_STATUS_BUTTON_CONFIG[props.status?.toLowerCase()];

  return statusConfig ? (
    <Tooltip title={props.tooltip}>
      <button id={props.id} type="button" className={statusConfig.className}>
        {statusConfig.text}
      </button>
    </Tooltip>
  ) : (
    ''
  );
};

PaymentStatus.propTypes = {
  id: PropTypes.string,
  status: PropTypes.string,
  tooltip: PropTypes.string,
};

export default PaymentStatus;
